import type {
  PreviewBusiness,
  PreviewCallLog,
  PreviewContact,
  PreviewEmailMessage,
  PreviewHousehold,
  PreviewMeeting,
  PreviewProject,
  PreviewSMSMessage,
  PreviewTrust,
} from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export type PeekViewRecordType =
  | "Household"
  | "Meeting"
  | "Business"
  | "Contact"
  | "Person"
  | "Trust"
  | "Syncbox::Message"
  | "SMSMessage"
  | "CallLog"
  | "Project"

export type PeekViewData =
  | PreviewHousehold
  | PreviewMeeting
  | PreviewBusiness
  | PreviewContact
  | PreviewTrust
  | PreviewEmailMessage
  | PreviewSMSMessage
  | PreviewCallLog
  | PreviewProject

export async function fetchPeekViewData(
  context: ApiContext,
  recordType: PeekViewRecordType,
  recordId: string
): Promise<PeekViewData> {
  const params = new URLSearchParams()
  params.append("record_type", recordType)
  params.append("record_id", recordId)

  return await apiContextFetch<PeekViewData>(context, `peek_view?${params.toString()}`)
}
